import { useState, useEffect, useCallback } from "react";
import { hashToRouteId, type RouteId } from "../lib/routes";

export function useRouter() {
  const [currentRoute, setCurrentRoute] = useState<RouteId>(() =>
    hashToRouteId(window.location.hash || "#/dashboard"),
  );

  useEffect(() => {
    function handleHashChange() {
      setCurrentRoute(hashToRouteId(window.location.hash));
    }
    window.addEventListener("hashchange", handleHashChange);
    // Set initial hash if empty
    if (!window.location.hash) {
      window.location.hash = "#/dashboard";
    }
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const navigate = useCallback((route: RouteId) => {
    window.location.hash = `#/${route}`;
  }, []);

  return { currentRoute, navigate };
}
